import {post} from "../utils";
import {makeFormData} from "./utils";

export default host => ({
  name,
  description,
  streamId,
  startTime,
  endTime,
  videoId,
  startImageId,
  endImageId,
  fake,
  source,
  contentCreatorId,
}) => {
  return post(`${host}/livestreams`,
    makeFormData({
      name,
      description,
      streamId,
      startTime,
      endTime,
      videoId,
      startImageId,
      endImageId,
      fake,
      source,
      contentCreatorId,
    }))
    .then(response => response.json())
    .then(response => response.data)
}
